import React, { useState } from 'react';
import ScrollToTop from '../components/ScrollToTop';
import Footer from '../components/Footer';
import NavbarHeader from '../components/NavbarHeader';
import TermsOfService from '../components/TermsOfServiceForms';

function TermsPage() {
    const [isOpen, setIsOpen] = useState(false);

    const toggle = () => {
        setIsOpen(!isOpen);
    };

    return (
        <>
            <ScrollToTop />
            <NavbarHeader toggle={toggle} />
            <TermsOfService />
            <Footer />
        </>
    );
}

export default TermsPage;

